import axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from "axios";
import router from "./../router/index";
import {keycloak} from "@/utils/keycloak";

export const ApiService = {
  setupInterceptor() {
    axios.interceptors.request.use(this.handleSuccess, this.handleErrorRequest); // Handle request success
    axios.interceptors.response.use(this.handleResponseSuccess, this.handleErrorResponse); // Handle response success and error
  },

  // Request success handler (adds token to the request)
  handleSuccess(config: AxiosRequestConfig): AxiosRequestConfig {
    const token = keycloak.token;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },

  // Request error handler
  handleErrorRequest(error: any): Promise<any> {
    // Always return a rejected promise in case of error
    return Promise.reject(error);
  },

  // Response success handler
  handleResponseSuccess(response: AxiosResponse): AxiosResponse {
    return response; // Just return the response as is
  },

  // Response error handler
  handleErrorResponse(error: any): Promise<any> {
    if (!error.response) {
      // Network error
      let errorResponse = {
        response: {
          data: "Netzwerkfehler",
        },
      };
      return Promise.reject(errorResponse);
    }

    if (error.response.status === 401) {
     router.push("login"); // Redirect to login on 401 Unauthorized
    }

    // For other errors, reject the promise
    return Promise.reject(error);
  },

  // GET request with token
  get(url: string): Promise<AxiosResponse> {
    return axios.get(url);
  },

  // GET request with responseType blob
  gets(url: string): Promise<AxiosResponse> {
    return axios.get(url, {
      responseType: "blob",
    });
  },

  // POST request with data
  post(url: string, data: { [key: string]: any }): Promise<AxiosResponse> {
    return axios.post(url, data);
  },

  // Custom request with config
  custom(config: AxiosRequestConfig): AxiosPromise<any> {
    return axios(config);
  },
};
